import { ScrollView, View } from 'react-native';
import StyleSheet from 'react-native-media-query';
import Popup from 'reactjs-popup';
import { Layout, Text } from '@ui-kitten/components';
import lodashIsEmpty from 'lodash/isEmpty';
import lodashIsUndefined from 'lodash/isUndefined';
import { UAParser } from 'ua-parser-js';

import ThemeColor from '../../../Theme/colors';
import ThemeStyle from '../../../Theme/styles';
import BreakPoints from '../../../Theme/styles/breakpoints';

import CloseButton from '../CloseButton';

import { PopupModalProp } from './types';

import './index.css';

const PopupModal = ({
  isOpen = false,
  onClosed,
  onCloseButtonClick,
  baseWidth = 550,
  title = '',
  closeButtonColor,
  closeOnDocumentClick = false,
  dataSet,
  mainContentWrapperStyle,
  childContentContainerStyle,
  hasHeader = true,
  hasHeaderLine,
  hasFooterLine = false,
  headerStyle,
  footerStyle,
  children,
  footer,
  withCloseButton = true,
  scrollEnabled = true,
  coverOverlayScreen,
}: PopupModalProp) => {
  const { device } = UAParser();
  const contentStyle = {
    background: 'transparent',
  };
  const overlayStyle = { background: 'rgba(0,0,0,0.5)' };
  const arrowStyle = { color: '#000' }; // style for an svg element
  const ChildrenWrapper = scrollEnabled ? ScrollView : View;
  return (
    <Popup
      open={isOpen}
      closeOnDocumentClick={closeOnDocumentClick}
      closeOnEscape={false}
      onClose={(e) => {
        e?.preventDefault?.();
        onClosed?.();
      }}
      modal
      nested
      contentStyle={contentStyle}
      overlayStyle={overlayStyle}
      arrowStyle={arrowStyle}
    >
      {
        //@ts-ignore
        (close) => {
          return (
            <View
              dataSet={
                !coverOverlayScreen &&
                device.type !== 'mobile' && {
                  media: Boolean(dataSet?.media)
                    ? dataSet?.media
                    : ids.mainContentWrapper,
                }
              }
              style={
                coverOverlayScreen
                  ? styles.coverOverlayScreen
                  : [
                      { width: baseWidth },
                      styles.mainContentWrapper,
                      mainContentWrapperStyle,
                    ]
              }
            >
              {hasHeader && (
                <View
                  style={[
                    hasHeaderLine
                      ? styles.headerContainer2
                      : styles.headerContainer,
                    headerStyle,
                  ]}
                >
                  {!lodashIsEmpty(title) && typeof title === 'string' ? (
                    <Layout level="1">
                      <Text category="s2">{title}</Text>
                    </Layout>
                  ) : (
                    title
                  )}
                  {withCloseButton && (
                    <View
                      style={
                        hasHeaderLine
                          ? styles.closeButtonContainer2
                          : styles.closeButtonContainer
                      }
                    >
                      <CloseButton
                        fill={closeButtonColor}
                        onPress={onCloseButtonClick || close}
                      />
                    </View>
                  )}
                </View>
              )}
              <ChildrenWrapper
                style={[
                  coverOverlayScreen
                    ? styles.childCoverOverlayScreen
                    : styles.contentContainer,
                  childContentContainerStyle,
                ]}
                {...(scrollEnabled && {
                  contentContainerStyle: { flexGrow: 1 },
                  nestedScrollEnabled: true,
                })}
              >
                {children}
              </ChildrenWrapper>

              {!lodashIsUndefined(footer) && (
                <View
                  style={[
                    styles.contentFooterContainer,
                    hasFooterLine && styles.hasFooterLine,
                    footerStyle,
                  ]}
                >
                  {footer}
                </View>
              )}
            </View>
          );
        }
      }
    </Popup>
  );
};

const { ids, styles } = StyleSheet.create({
  mainContentWrapper: {
    alignSelf: 'center',
    backgroundColor: ThemeColor.white,
    borderRadius: 10,
    overflow: 'hidden',
    // 100 dynamic viewport - 40px (spacing 20px top and 20px bottom)
    maxHeight: 'calc(100dvh - 40px)',
    maxWidth: 'calc(100dvw - 40px)',
  },
  coverOverlayScreen: {
    width: '100dvw',
    height: '100dvh',
  },
  childCoverOverlayScreen: { height: '100dvh' },
  contentContainer: {
    ...ThemeStyle.pageHorizontalSpacing,
    ...ThemeStyle.spacingBottomMedium,
  },
  contentFooterContainer: { ...ThemeStyle.spacingBottomMedium },
  headerContainer: {
    flex: 1,
    minHeight: 50,
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexDirection: 'row',
    ...ThemeStyle.pageHorizontalSpacing,
    ...ThemeStyle.spacingBottomSmall,
  },
  headerContainer2: {
    flex: 1,
    minHeight: 50,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: ThemeColor.lightGray,
    ...ThemeStyle.pageHorizontalSpacing,
    ...ThemeStyle.spacingBottomMedium,
  },
  hasFooterLine: {
    borderTopColor: ThemeColor.lightGray,
    borderTopWidth: 1,
  },
  closeButtonContainer: {
    width: '100%',
    position: 'absolute',
    alignItems: 'flex-end',
  },
  closeButtonContainer2: {
    width: '100%',
    position: 'absolute',
    alignItems: 'flex-end',
    paddingRight: 15,
  },
});
export default PopupModal;
